import { createFileRoute } from '@tanstack/react-router';

import { CompanyDetails } from 'features/account/CompanyDetails';

export const Route = createFileRoute('/_authenticated/account/_shell/company')({
  component: AccountCompanyRoute
});

function AccountCompanyRoute() {
  return <CompanyDetails />;
}
